var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0438 9.24414L14.8701 23.1565L25.9999 9.24414H19.0438Z",
    fill: "#2A2A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95617 9.24414H0L11.1298 23.1565L6.95617 9.24414Z",
    fill: "#2A2A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7443 7.71037L20.2033 2.16937C20.0605 2.02652 19.8667 1.94629 19.6647 1.94629H16.8433L19.0048 7.71037H25.7443Z",
    fill: "#2A2A3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99534 7.71037L9.15685 1.94629H6.33544C6.13343 1.94629 5.93965 2.02652 5.7968 2.16937L0.255859 7.71037H6.99534Z",
    fill: "#2A2A3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4424 9.24414H8.55713L12.9998 24.053L17.4424 9.24414Z",
    fill: "#2A2A3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6333 7.71037H17.3669L15.2053 1.94629H10.7949L8.6333 7.71037Z",
    fill: "#2A2A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA5);
export default __webpack_public_path__ + "static/media/a5.b5544acc03dcedfe9f128e904a20cb99.svg";
export { ForwardRef as ReactComponent };